import { useState } from 'react';
import { FiPercent, FiDollarSign, FiX } from 'react-icons/fi';

const DiscountModal = ({ applyDiscount, setShowDiscountModal, currentDiscount }) => {
  const [discountType, setDiscountType] = useState(currentDiscount?.type || 'percentage');
  const [discountValue, setDiscountValue] = useState(currentDiscount?.value || '');
  const [reason, setReason] = useState(currentDiscount?.reason || '');

  const handleApply = () => {
    if (!discountValue) return;
    
    applyDiscount({
      type: discountType,
      value: parseFloat(discountValue),
      reason
    });
  };

  const applyQuickDiscount = (value) => {
    applyDiscount({
      type: 'percentage',
      value,
      reason: 'Quick Discount'
    });
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md">
        <div className="p-6">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-xl font-bold text-gray-800">Apply Discount</h2>
            <button
              onClick={() => setShowDiscountModal(false)}
              className="text-gray-500 hover:text-gray-700"
            >
              <FiX size={20} />
            </button>
          </div>

          <div className="mb-6">
            <h3 className="font-medium text-gray-800 mb-2">Quick Discounts</h3>
            <div className="grid grid-cols-3 gap-2 mb-4">
              <button
                onClick={() => applyQuickDiscount(10)}
                className="px-3 py-2 border border-gray-200 rounded hover:bg-gray-100"
              >
                10% Off
              </button>
              <button
                onClick={() => applyQuickDiscount(15)}
                className="px-3 py-2 border border-gray-200 rounded hover:bg-gray-100"
              >
                15% Off
              </button>
              <button
                onClick={() => applyQuickDiscount(20)}
                className="px-3 py-2 border border-gray-200 rounded hover:bg-gray-100"
              >
                20% Off
              </button>
            </div>
            <div className="grid grid-cols-2 gap-2 mb-4">
              <button
                onClick={() => {
                  setDiscountType('fixed');
                  setDiscountValue(5);
                }}
                className="px-3 py-2 border border-gray-200 rounded hover:bg-gray-100"
              >
                $5 Off
              </button>
              <button
                onClick={() => {
                  setDiscountType('fixed');
                  setDiscountValue(10);
                }}
                className="px-3 py-2 border border-gray-200 rounded hover:bg-gray-100"
              >
                $10 Off
              </button>
            </div>
          </div>

          <div className="mb-4">
            <h3 className="font-medium text-gray-800 mb-2">Discount Type</h3>
            <div className="flex space-x-4 mb-4">
              <label className="inline-flex items-center">
                <input
                  type="radio"
                  className="form-radio text-gray-800"
                  name="discountType"
                  checked={discountType === 'percentage'}
                  onChange={() => setDiscountType('percentage')}
                />
                <span className="ml-2 flex items-center">
                  <FiPercent className="mr-1" /> Percentage
                </span>
              </label>
              <label className="inline-flex items-center">
                <input
                  type="radio"
                  className="form-radio text-gray-800"
                  name="discountType"
                  checked={discountType === 'fixed'}
                  onChange={() => setDiscountType('fixed')}
                />
                <span className="ml-2 flex items-center">
                  <FiDollarSign className="mr-1" /> Fixed Amount
                </span>
              </label>
            </div>

            <div className="mb-4">
              <label className="block text-gray-700 mb-1">
                {discountType === 'percentage' ? 'Percentage' : 'Amount'}
              </label>
              <div className="relative">
                {discountType === 'percentage' ? (
                  <FiPercent className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                ) : (
                  <FiDollarSign className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                )}
                <input
                  type="number"
                  className="w-full pl-10 pr-4 py-2 border border-gray-200 rounded-md focus:outline-none focus:ring-1 focus:ring-gray-800 focus:border-gray-800"
                  value={discountValue}
                  onChange={(e) => setDiscountValue(e.target.value)}
                  placeholder={discountType === 'percentage' ? '10' : '5.00'}
                />
              </div>
            </div>

            <div className="mb-4">
              <label className="block text-gray-700 mb-1">Reason (Optional)</label>
              <input
                type="text"
                className="w-full px-4 py-2 border border-gray-200 rounded-md focus:outline-none focus:ring-1 focus:ring-gray-800 focus:border-gray-800"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                placeholder="Happy Hour, Promotion, etc."
              />
            </div>
          </div>

          <div className="flex justify-end space-x-3">
            <button
              onClick={() => setShowDiscountModal(false)}
              className="px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-100"
            >
              Cancel
            </button>
            <button
              onClick={handleApply}
              className="px-4 py-2 bg-gray-800 text-white rounded-md hover:bg-gray-700"
            >
              Apply Discount
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DiscountModal;